(function() {
	'use strict';
	angular.module('app.dashboard', ['ui.sortable']);
})();
